<template>
  <div :class="[tooltip != null ? 'tooltip' : '']" :data-tip="tooltip">
    <button
      class="btn btn-accent w-24"
      @click="showDeleteModal = true"
      :disabled="backend.currentConfig == null || error != null"
    >
      Delete
    </button>

    <ModalConfirm
      v-if="backend.currentConfig?.name != undefined"
      v-model="showDeleteModal"
      title="Delete this configuration?"
      confirmName="Delete"
      @done="onDeleteModalDone"
    >
      <p>
        Are you sure you want to delete configuration
        <span class="kbd kbd-sm"> {{ backend.currentConfig.name }} </span>? This
        action cannot be undone.
      </p>
    </ModalConfirm>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { err } from "@/utils";
import { useBackendStore } from "@/stores";
import ModalConfirm from "@/components/utils/ModalConfirm.vue";

const backend = useBackendStore();

// Require user confirmation when deleting configuration
const showDeleteModal = ref(false);
const onDeleteModalDone = (confirmed: boolean) => {
  showDeleteModal.value = false;
  if (confirmed) backend.deleteCurrentConfig();
};

const error = computed(() => {
  if (backend.currentConfig == null) return null;
  if (!backend.userLoggedIn) {
    return "Log in to delete your configuration";
  }
  if (!backend.userIsOwner) {
    return "This configuration cannot be modified";
  }
  return null;
});

const tooltip = computed(() => {
  if (backend.currentConfig == null) return null;
  if (error.value != null) return err(error.value);
  return "Delete current configuration";
});
</script>
